import type { FaireProductEntity } from "../../entity_types/product";

export const p_68cdhm7qkw: FaireProductEntity = {
  token: "p_68cdhm7qkw",
  type: "product",
  name: "Ceramic Vase, Strawberry Milk",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/58b26fb5a23b082fa0bfa43e017d3220bc7fe5c881217d61fcdae789c46a1794.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90e7b9cc048a0ea130f03894853e221c5e5c170ac69ef5b5d953f234afc42d30.jpeg",
    "https://cdn.faire.com/fastly/17cf0e34b1fd3134a613565483d2a8944fe857d356efcc66b57f792afbf66fb7.jpeg",
    "https://cdn.faire.com/fastly/159737637654a4eba5e462cf8ca71f3bc1e3040bb5121780d85ed1052b1e0c45.jpeg"
  ],
  priceDollars: 13,
  description: "Gulp. We made a new ceramic vase. It’s not quite milk and it’s not quite a strawberry—it’s strawberry milk! This sweet and whimsical Bando vase is made of high-quality ceramic and is just as fun as it sounds. Use it to hold fresh flowers, dried blooms, or even pens and pencils—because who says your desk or shelf décor can’t be a little delicious-looking?\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Made of durable, high-quality ceramic\n• Strawberry milk–inspired design for a playful touch\n• Perfect for flowers, plants, or desktop organization\n• Adds instant charm to any home, office, or studio space\n• Designed in Bando’s signature bright and joyful aesthetic\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n• Gift shops and home décor boutiques\n• Lifestyle retailers and stationery stores\n• Floral shops and event stylists\n• Wholesale buyers seeking fun, eye-catching ceramic décor",
  tags: [],
  msrpDollars: 26.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:42.220Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
